export default __webpack_public_path__ + "static/media/ic_wcro_225.49fc2f46.svg";